import { SimpleForm, Toolbar, SaveButton } from 'react-admin'
import { Box, Tabs, Tab, Paper } from '@mui/material'
import { useState } from 'react'

/**
 * CustomTabbedForm - A reusable form component with general fields and tabbed fields
 *
 * @param {Array} generalFields - Array of React elements to render in the general section (above tabs)
 * @param {Array} tabs - Array of tab objects with structure: { label: string, fields: Array<ReactElement> }
 * @param {Object} formProps - Additional props to pass to the Form component
 */
export const CustomTabbedForm = ({ generalFields = [], tabs = [], ...formProps }) => {
  const [tabValue, setTabValue] = useState(0)
  const { transform, ...simpleFormProps } = formProps

  return (
    <SimpleForm
      {...simpleFormProps}
      toolbar={
        <Toolbar>
          <SaveButton type="button" transform={transform} />
        </Toolbar>
      }
    >
      {generalFields.length > 0 && (
        <Box sx={{ mb: 1, px: 1, pt: 2, width: '100%' }}>{generalFields}</Box>
      )}
      {tabs.length > 0 && (
        <Paper sx={{ mt: 2, width: '100%' }}>
          <Tabs
            value={tabValue}
            onChange={(_, newValue) => setTabValue(newValue)}
            aria-label="form tabs"
          >
            {tabs.map((tab) => (
              <Tab key={tab.label} label={tab.label} />
            ))}
          </Tabs>
          {tabs.map((tab, index) => (
            <Box key={tab.label} role="tabpanel" hidden={tabValue !== index} sx={{ p: 3 }}>
              {tabValue === index && <>{tab.fields}</>}
            </Box>
          ))}
        </Paper>
      )}
    </SimpleForm>
  )
}
